
import Button from '../../../components/base/Button';

export default function ServicesGrid() {
  const services = [
    {
      icon: 'ri-alarm-warning-line',
      title: 'Fire Alarm Systems',
      description: 'Design, supply, and installation of intelligent and conventional fire alarm systems. Ensuring early detection and fast response to protect lives and assets.',
      cta: 'Get a Quote',
      image: 'https://readdy.ai/api/search-image?query=Modern%20fire%20alarm%20control%20panel%20with%20digital%20display%20and%20red%20indicator%20lights%2C%20professional%20fire%20detection%20system%20installation%20in%20Qatar%20commercial%20building%2C%20QCDD%20approved%20fire%20safety%20equipment%20with%20clean%20technical%20background&width=400&height=300&seq=fire-alarm&orientation=landscape'
    },
    {
      icon: 'ri-fire-line',
      title: 'Fire Fighting Systems',
      description: 'Complete fire suppression solutions — sprinklers, hydrants, pumps, and hose reels. Engineered and installed to meet Qatar\'s fire safety codes and building standards.',
      cta: 'Learn More',
      image: 'https://readdy.ai/api/search-image?query=Fire%20sprinkler%20system%20installation%20with%20red%20pipes%20and%20sprinkler%20heads%20in%20Qatar%20commercial%20ceiling%2C%20professional%20fire%20suppression%20equipment%20and%20hydrant%20systems%2C%20QCDD%20compliant%20fire%20fighting%20infrastructure%20with%20clean%20industrial%20background&width=400&height=300&seq=fire-fighting&orientation=landscape'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Emergency Lighting Systems',
      description: 'Reliable lighting systems for safe evacuation during power failures or emergencies. Includes illuminated exit signage and automatic power backup integration.',
      cta: 'Request Consultation',
      image: 'https://readdy.ai/api/search-image?query=Emergency%20exit%20lighting%20and%20illuminated%20safety%20signs%20in%20Qatar%20commercial%20building%20corridor%2C%20professional%20emergency%20lighting%20system%20with%20backup%20power%20integration%2C%20clean%20modern%20safety%20infrastructure%20with%20red%20exit%20indicators&width=400&height=300&seq=emergency-lighting&orientation=landscape'
    },
    {
      icon: 'ri-shield-line',
      title: 'Fire Extinguishers Supply & Maintenance',
      description: 'Supply, refilling, and servicing of CO₂, dry chemical, and foam fire extinguishers. All equipment is QCDD-approved and certified for commercial and industrial use.',
      cta: 'Get a Quote',
      image: 'https://readdy.ai/api/search-image?query=Professional%20fire%20extinguisher%20maintenance%20service%20in%20Qatar%2C%20red%20CO2%20and%20dry%20chemical%20fire%20extinguishers%20being%20serviced%20by%20certified%20technicians%2C%20QCDD%20approved%20fire%20safety%20equipment%20with%20clean%20technical%20background&width=400&height=300&seq=extinguishers&orientation=landscape'
    },
    {
      icon: 'ri-camera-line',
      title: 'CCTV & Access Control Systems',
      description: 'Smart surveillance and access control solutions to enhance overall safety. Integration with fire and alarm systems for complete property monitoring.',
      cta: 'Request Demo',
      image: 'https://readdy.ai/api/search-image?query=Modern%20CCTV%20security%20cameras%20and%20access%20control%20systems%20in%20Qatar%20commercial%20building%2C%20integrated%20surveillance%20technology%20with%20fire%20safety%20monitoring%2C%20professional%20security%20equipment%20installation%20with%20clean%20technical%20background&width=400&height=300&seq=cctv-access&orientation=landscape'
    },
    {
      icon: 'ri-tools-line',
      title: 'Annual Maintenance Contracts (AMC)',
      description: 'Regular inspections, testing, and maintenance for all fire protection systems. Ensure compliance, safety, and peace of mind — all year round.',
      cta: 'Contact Us',
      image: 'https://readdy.ai/api/search-image?query=Fire%20safety%20engineer%20performing%20annual%20maintenance%20inspection%20on%20fire%20alarm%20system%20in%20Qatar%2C%20professional%20technician%20testing%20fire%20protection%20equipment%20with%20QCDD%20compliance%20checklist%2C%20clean%20technical%20maintenance%20service%20background&width=400&height=300&seq=amc-maintenance&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100"
            >
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4 w-12 h-12 flex items-center justify-center bg-red-600 rounded-xl shadow-lg">
                  <i className={`${service.icon} text-xl text-white`}></i>
                </div>
              </div>
              
              <div className="p-8">
                <h3 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-red-600 transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed mb-6">
                  {service.description}
                </p>
                <Button 
                  variant="outline" 
                  className="w-full group-hover:bg-red-600 group-hover:text-white group-hover:border-red-600"
                >
                  {service.cta}
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}